import React from 'react';

function Header() {
    return (
        <header style={{
            backgroundColor: '#000',
            padding: '20px 20px',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            animation: 'pulseColor 2s infinite'
        }}>
            <img src={process.env.REACT_APP_VISION_AI_STREAM_LOGO_PATH} alt="VisionAIStream - Video Editor" style={{
                maxWidth: '100%',
                height: 'auto',
                maxHeight: '150px'
            }} />
        </header>
    );
}

export default Header;
